// Clipart management using Vite's import.meta.glob
// Automatically discovers all SVG files in assets/clipart folders

// Import all SVG files from clipart folders
const clipartFiles = import.meta.glob('../assets/clipart/**/*.svg', { eager: true, as: 'url' });

/**
 * Organizes clipart files by category (folder name)
 * @returns {Object} Categories with their clipart items
 */
export function getClipartCategories() {
  const categories = {};
  
  Object.keys(clipartFiles).forEach(path => {
    // Extract category and filename from path
    // Path format: ../assets/clipart/animals/cat.svg
    const match = path.match(/\/clipart\/([^\/]+)\/([^\/]+)$/);
    
    if (match) {
      const [, category, filename] = match;
      const name = filename.replace('.svg', '');
      const url = clipartFiles[path];
      
      if (!categories[category]) {
        categories[category] = [];
      }
      
      categories[category].push({
        name,
        filename,
        url,
        category
      });
    }
  });
  
  return categories;
}

/**
 * Loads an SVG file and returns its content as a string
 * @param {string} url - The URL of the SVG file
 * @returns {Promise<string>} The SVG content
 */
export async function loadSvgContent(url) {
  try {
    const response = await fetch(url);
    const svgText = await response.text();
    return svgText;
  } catch (error) {
    console.error('Error loading SVG:', error);
    return null;
  }
}

/**
 * Formats category name for display (e.g., "animals" -> "Animals")
 * @param {string} category - The category name
 * @returns {string} Formatted category name
 */
export function formatCategoryName(category) {
  return category
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
